export * from './icon.component';
export * from './icon-upload.component';
